function Completion(props) {
  return (
    <h1 sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>תודה רבה! 🎉</h1>
  );
}

export default Completion;
